<template>
  <div class="asc-mxrec-confirm-submit-dialog">
    <asc-dialog
      :show-dialog="showDialog"
      :text="getTitleText"
      :on-primary="handleAccept"
      :on-secondary="handleReject"
      :on-close="handleReject"
      :primary-available="noTechDataConfirmed"
      secondary-button-text="cancel"
      :primary-button-text="isPostSubmittalStatus ? 'save' : 'submit'"
    >
      <div v-if="!isPostSubmittalStatus">
        By clicking "Submit", you will allow this maintenance recommendation to
        be viewable by external customers. Please choose to Submit or Cancel.
      </div>
      <asc-checkbox
        v-model="noTechDataConfirmed"
        :label="getTechDataText"
      ></asc-checkbox>
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscCheckbox from '@/components/atoms/AscCheckbox'

export default {
  name: 'AscMxRecConfirmSubmitDialog',

  components: {
    AscDialog,
    AscCheckbox,
  },

  mixins: [AscDialogMixin],

  props: {
    isPostSubmittalStatus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      noTechDataConfirmed: false,
    }
  },

  computed: {
    getTitleText() {
      return 'Are you sure you want to submit?'
    },
    getTechDataText() {
      return 'I confirm that the information/data within this document/screen contains ONLY Low Tech Data/Information; technical data/information that does not require an export authorization in any relevant jurisdiction to any countries except those subject to a comprehensive embargo.'
    },
  },

  methods: {
    handleAccept() {
      this.onAccept()
      this.handleClose()
      this.noTechDataConfirmed = false
    },
    handleReject() {
      this.handleClose()
      this.noTechDataConfirmed = false
    },
  },
}
</script>
<style lang="scss">
.asc-mxrec-confirm-submit-dialog {
  .asc-dialog {
    .v-card__text {
      min-height: auto !important;
      padding: 0 16px 16px 19px !important;
      letter-spacing: 0;
      line-height: 18px;
    }

    .asc-checkbox {
      white-space: normal;
      margin-top: 27px;
      margin-right: 0;

      .state label {
        text-indent: 0;
        padding-left: 2rem;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;

        &::before,
        &::after {
          top: 0;
        }
      }

      &.p-icon .state .icon {
        top: 0;
      }
    }
  }
}
</style>
